import useSWR from 'swr';
import { useToken } from '../auth/token';
import { useApiClient } from '@/app/contexts/DemoTradeContext';
import React from 'react';

export function useTradePosition() {
  let list: any = [];
  const [mitLengtht, setMitLengtht] = React.useState(0);
  const { data: token, getLatestToken } = useToken();
  const { api } = useApiClient(); // ✅ Context에서 API 클라이언트 가져오기
  const KEYURL = '/trade/status';

  const {
    data = [],
    mutate,
    isLoading,
  } = useSWR(
    token ? KEYURL : null,
    async () => {
      // ✅ 항상 최신 토큰 사용 (Refresh 후에도 정상 동작)
      const currentToken = getLatestToken();
      // ✅ Context를 통해 Demo/Real API 자동 선택
      const response = await api.get(KEYURL, currentToken + '', {}, false);
      const result = response?.result?.result;

      // ✅ open_price를 price로 매핑하여 호환성 유지
      if (result?.open_positions) {
        result.open_positions = result.open_positions.map((position: any) => ({
          ...position,
          price: position.open_price ?? position.price ?? 0, // nullish coalescing으로 안전하게 처리
        }));
      }

      return result;
    },
    { revalidateOnFocus: true, refreshInterval: 60 * 1000 }
  );

  data?.open_positions?.map((item: any) => {
    if (item?.tpsl) {
      const TPSL = item?.tpsl

      if (TPSL) {
        if (+TPSL?.tp != 0) {
          list = [
            {
              ...item,
              posid: item?.id,
              posprice: item?.price,
              poslongshort: item?.long_short,
              status: 1,
              limit_market: 'L',
              long_short: item?.long_short == 'L' ? 'S' : 'L',
              order_price: +TPSL?.tp,
              type: 'TP',
              tpsltype: TPSL?.tp + ' ' + TPSL?.tptype,
              tpsl: TPSL,
            },
            ...list,
          ];
        }
        if (+TPSL?.sl != 0) {
          list = [
            {
              ...item,
              posid: item?.id,
              posprice: item?.price,
              poslongshort: item?.long_short,
              status: 1,
              limit_market: 'L',
              long_short: item?.long_short == 'L' ? 'S' : 'L',
              order_price: +TPSL?.sl,
              type: 'SL',
              tpsltype: TPSL?.sl + ' ' + TPSL?.sltype,
              tpsl: TPSL,
            },
            ...list,
          ];
        }
      }
    }
  });

  // console.log("mitLengtht", mitLengtht);

  return {
    data: data?.open_positions,
    orderlist: data?.order,
    spot: data?.spot,
    futures: data?.futures,
    global: data?.global,
    tpslList: list,
    mutate,
    mitLengtht: mitLengtht,
    isLoading: isLoading,
    setMitLengtht: (value: number) => {
      setMitLengtht(value);
    },
  };
}
